export default "__VITE_ASSET__517e31dc__"